import { ComponentType } from 'react';
import styled, { css } from 'styled-components';
import { AllieThumbsDownOutlineIcon, AllieThumbsUpOutlineIcon } from '../../../../../styling/icons';
import { IonSegment, IonSegmentButton } from '@ionic/react';
import { AllieLikeDislikeButtonProps } from '../../LikeDislike.types';
import { IonSegmentProps } from '../../../../../common/components.types';

export const StyledContainer: ComponentType<IonSegmentProps & { size: number }> = styled(
  IonSegment
)<{ size: number }>`
  width: ${(props) => props.size * 3.75}px;
  background-color: var(--allie-color-neutral-10);
  border-radius: 50px;
  border: 2px solid var(--allie-color-neutral-20);
`;

export const StyledLikeDislike: ComponentType<
  AllieLikeDislikeButtonProps & { isLike?: boolean; size: number }
> = styled(IonSegmentButton)<AllieLikeDislikeButtonProps & { isLike?: boolean; size: number }>`
  --padding-start: 0;
  --padding-end: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  --indicator-color: ${(props: AllieLikeDislikeButtonProps) =>
    `var(--allie-color-${props.allieColor})`};
  --border-radius: 50px;
  min-width: ${(props) => props.size * 1.875}px;

  ${(props) =>
    props.isLike
      ? css`
          --border-radius: 0 50px 50px 0;
        `
      : css`
          --border-radius: 50px 0 0 50px;
        `}
`;

export const StyledDislike = styled(AllieThumbsDownOutlineIcon)<{
  selected: boolean;
  fontSize: number;
}>`
  color: ${(props) =>
    props.selected ? 'var(--allie-color-error-10)' : 'var(--allie-color-neutral-40)'};
  font-size: ${(props) => props.fontSize}px;
`;

export const StyledLike = styled(AllieThumbsUpOutlineIcon)<{
  selected: boolean;
  fontSize: number;
}>`
  color: ${(props) =>
    props.selected ? 'var(--allie-color-success-10)' : 'var(--allie-color-neutral-40)'};
  font-size: ${(props) => props.fontSize}px;
`;
